import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Card, Breadcrumb, Table, CardHeader, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';
import successVideo from '../../assets/video/paperplane.mp4';
import crossVideo from '../../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from 'primereact/progressspinner';
const Template_invoice_edit = () => {
    const { accessToken } = useAuth();
    const { templateId } = useParams();
    const navigate = useNavigate();
    const [Loading, setLoading] = useState(false); // Add loading state
    const [isLoading, setIsLoading] = useState(false); // Add loading state
    const [templateData, setTemplateData] = useState({
        templateName: "",
        invoicePrefix: "",
        financialYear: "",
        signatureBottomText: "",
        headerText: "",
        GSTIN: "",
        PAN: "",
        companyName: "",
        bankName: "",
        accountNumber: "",
        bankBranch: "",
        ifscCode: "",
        swiftCode: "",
        companyAddress: "",
        contactNo: null,
        email: "",
        Lut_Arn_No: "",
        MSME_Type: "",
        MSME_Number: "",
    });


    const [prevsignatureFile, setprevSignatureFile] = useState(null);
    const [prevheaderLogoFile, setprevHeaderLogoFile] = useState(null);

    const [signatureFile, setSignatureFile] = useState(null);
    const [headerLogoFile, setHeaderLogoFile] = useState(null);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog



    useEffect(() => {
        // Fetch template data
        const fetchTemplateData = async () => {
            setLoading(true); // Set loading state
            try {
                const response = await axios.get(`${config.apiBASEURL}/templateRoutes/fetch-template/${templateId}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                const { template } = response.data;

                setTemplateData({
                    templateName: template.template_name,
                    invoicePrefix: template.invoice_prefix,
                    financialYear: template.financial_year,
                    signatureBottomText: template.signature_bottom_text,
                    headerText: template.header_text,
                    GSTIN: template.GSTIN,
                    PAN: template.PAN,
                    companyName: template.company_name,
                    bankName: template.bank_name,
                    accountNumber: template.account_number,
                    bankBranch: template.bank_branch,
                    ifscCode: template.ifsc_code,
                    swiftCode: template.swift_code,
                    companyAddress: template.company_address,
                    contactNo: template.contact_no,
                    email: template.email,
                    Lut_Arn_No: template.Lut_Arn_No,
                    MSME_Type: template.MSME_Type,
                    MSME_Number: template.MSME_Number,
                });
                // Set the previous header logo and signature
                if (template.headerLogos && template.headerLogos.length > 0) {
                    setprevHeaderLogoFile(template.headerLogos[0].header_logo_url);
                }
                if (template.signatures && template.signatures.length > 0) {
                    setprevSignatureFile(template.signatures[0].signature_url);
                }

            } catch (error) {
                console.error('Error fetching template:', error);
            }
            finally {
                setLoading(false); // Stop loading
            }
        };

        fetchTemplateData();
    }, [accessToken, templateId]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setTemplateData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (name === 'signatureFile') {
            setSignatureFile(files[0]);
        } else if (name === 'headerLogoFile') {
            setHeaderLogoFile(files[0]);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        for (const key in templateData) {
            formData.append(key, templateData[key]);
        }

        if (signatureFile) formData.append('signatureFile', signatureFile);
        if (headerLogoFile) formData.append('headerLogoFile', headerLogoFile);

        try {
            setIsLoading(true); // Set loading state
            const response = await axios.put(`${config.apiBASEURL}/templateRoutes/edit-template/${templateId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (response.status === 200) {

                setVideoDialogVisible(true); // Show video dialog
                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 6 seconds
                    navigate('/Graphe/dashboard/template_invoice_list');
                }, 5000);
            }
        } catch (error) {
            console.error("Error adding template:", error);
            setVideocrossDialogVisible(true); // Show video dialog

            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide video dialog after 6 seconds          
            }, 5000);
        }
        finally {
            setIsLoading(false); // Stop loading
        }
    };








    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={12} className="mb-4 d-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Edit Template</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    {Loading ? (
                        <Col sm={12} className='p-0'>
                            <ProgressSpinner />
                        </Col>
                    ) : (
                        <Col sm={12} className="p-0">
                            <Row>
                                <Col lg={7}>
                                    <Form onSubmit={handleSubmit}>
                                        <Card className='h-auto sticky-top'>
                                            <Card.Header className='bg-light'>
                                                <p className='mb-0 text-muted'>
                                                    <small>
                                                        <em className='text-danger'>Note :</em> All draft invoices made with this template will be updated with the new changes in this invoice template. There will be no change in the invoices sent Previously.
                                                    </small>
                                                </p>
                                            </Card.Header>
                                            <Card.Body className='pb-0'>

                                                <Row className='mx-0'>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Template Name </label>
                                                        <InputText
                                                            name="templateName"
                                                            value={templateData.templateName}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Invoice Prefix
                                                            <i
                                                                className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                                data-pr-tooltip="Note: If you change financial year and prefix of invoice template, invoice count will reset."
                                                                data-pr-position="right"
                                                                data-pr-at="right+5 top"
                                                                data-pr-my="left center-2"
                                                            >
                                                            </i>
                                                            <Tooltip target=".custom-target-icon" />
                                                        </label>
                                                        <InputText
                                                            name="invoicePrefix"
                                                            value={templateData.invoicePrefix}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>
                                                            Financial Year
                                                            <i
                                                                className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                                data-pr-tooltip="Note: If you change financial year and prefix of invoice template, invoice count will reset."
                                                                data-pr-position="right"
                                                                data-pr-at="right+5 top"
                                                                data-pr-my="left center-2"
                                                            >
                                                            </i>
                                                            <Tooltip target=".custom-target-icon" />
                                                        </label>
                                                        <InputText
                                                            name="financialYear"
                                                            value={templateData.financialYear}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Logo
                                                            <i
                                                                className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                                data-pr-tooltip="Note: If you dont change the logo, the previous logo will be retained."
                                                                data-pr-position="right"
                                                                data-pr-at="right+5 top"
                                                                data-pr-my="left center-2"
                                                            >
                                                            </i>
                                                            <Tooltip target=".custom-target-icon" />

                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="headerLogoFile"
                                                            accept="image/*"
                                                            onChange={handleFileChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Signature
                                                            <i
                                                                className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                                data-pr-tooltip="Note: If you dont change the signature, the previous signature will be retained."
                                                                data-pr-position="right"
                                                                data-pr-at="right+5 top"
                                                                data-pr-my="left center-2"
                                                            >
                                                            </i>
                                                            <Tooltip target=".custom-target-icon" />

                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="signatureFile"
                                                            accept="image/*"
                                                            onChange={handleFileChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Signature Text</label>
                                                        <InputText
                                                            name="signatureBottomText"
                                                            value={templateData.signatureBottomText}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Header Text</label>
                                                        <InputText
                                                            name="headerText"
                                                            value={templateData.headerText}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>GSTIN</label>
                                                        <InputText
                                                            name="GSTIN"
                                                            value={templateData.GSTIN}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>PAN No.</label>
                                                        <InputText
                                                            name="PAN"
                                                            value={templateData.PAN}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'> 
                                                        <label>MSME Type.</label>
                                                        <InputText
                                                            name="MSME_Type"
                                                            value={templateData.MSME_Type}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>MSME No.</label>
                                                        <InputText
                                                            name="MSME_Number"
                                                            value={templateData.MSME_Number}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Lut Arn No.</label>
                                                        <InputText
                                                            name="Lut_Arn_No"
                                                            value={templateData.Lut_Arn_No}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Company Name</label>
                                                        <InputText
                                                            name="companyName"
                                                            value={templateData.companyName}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Bank Name</label>
                                                        <InputText
                                                            name="bankName"
                                                            value={templateData.bankName}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Account No.</label>
                                                        <InputText
                                                            name="accountNumber"
                                                            value={templateData.accountNumber}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Branch Name</label>
                                                        <InputText
                                                            name="bankBranch"
                                                            value={templateData.bankBranch}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>IFSC Code</label>
                                                        <InputText
                                                            name="ifscCode"
                                                            value={templateData.ifscCode}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <label>Swiift Code</label>
                                                        <InputText
                                                            name="swiftCode"
                                                            value={templateData.swiftCode}
                                                            onChange={handleChange}
                                                        />
                                                    </Col>
                                                    <Col lg={4} md={6} className='px-1 mb-3'>
                                                        <div className='mb-2'>
                                                            <label>Company Email</label>
                                                            <InputText
                                                                name="email"
                                                                value={templateData.email}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div>
                                                            <label>Contact No.</label>
                                                            <InputNumber
                                                                inputId="contactNumber"
                                                                className="w-100"
                                                                value={templateData.contactNo}
                                                                onValueChange={(e) =>
                                                                    setTemplateData({ ...templateData, contactNo: e.value })
                                                                }
                                                                useGrouping={false}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg={8} md={6} className='px-1 mb-3'>
                                                        <label>Company Address</label>
                                                        <InputTextarea
                                                            name="companyAddress"
                                                            value={templateData.companyAddress}
                                                            onChange={handleChange}
                                                            rows={5}
                                                            cols={30}
                                                            className="h-auto"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                            <Card.Footer className='d-flex justify-content-end border-0'>
                                                <Button
                                                    label="Reset"
                                                    icon="pi pi-refresh"
                                                    className="py-2 me-2"
                                                    severity="secondary"
                                                    type="button" // Prevent the form submission
                                                    onClick={() => {
                                                        setTemplateData({
                                                            templateName: "",
                                                            invoicePrefix: "",
                                                            financialYear: "",
                                                            signatureBottomText: "",
                                                            headerText: "",
                                                            GSTIN: "",
                                                            PAN: "",
                                                            companyName: "",
                                                            bankName: "",
                                                            accountNumber: "",
                                                            bankBranch: "",
                                                            ifscCode: "",
                                                            swiftCode: "",
                                                            companyAddress: "",
                                                            contactNo: null,
                                                            email: "",
                                                            Lut_Arn_No: "",
                                                            MSME_Type: "",
                                                            MSME_Number: "",
                                                        });
                                                        setHeaderLogoFile(null);
                                                        setSignatureFile(null);
                                                    }}
                                                />
                                                <Button
                                                    label='Update'
                                                    icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                                                    className="py-2"
                                                    severity="help"
                                                    type="submit"
                                                    disabled={isLoading} // Disable button during loading
                                                />
                                            </Card.Footer>
                                        </Card>
                                    </Form>
                                </Col>
                                <Col lg={5} className=''>
                                    <Card className='shadow-sm'>
                                        <Card.Body className='p-0'>
                                            <div className="inv-Div">
                                                <div className="inv_header">
                                                    <div className="logo_part">
                                                        {headerLogoFile ? (
                                                            <img
                                                                src={URL.createObjectURL(headerLogoFile)}
                                                                alt=""

                                                            />
                                                        ) : (
                                                            <img
                                                                src={prevheaderLogoFile || require("../../assets/images/logo.png")}
                                                                alt=''
                                                            />
                                                        )}
                                                    </div>
                                                    <span>
                                                        <b>{templateData.headerText || "NA"}</b>
                                                    </span>
                                                </div>
                                                <div className="inv_address">
                                                    <div>
                                                        <p><span>BILLED TO :</span> Billing Company Name</p>
                                                        <p><span>Address :</span> Billing Address</p>
                                                        <p><span>GSTIN / UIN :</span> XXXXXXXXXXXXXXX</p>
                                                        <p><span>PAN / IT NO :</span> XXXXXXXXXX</p>
                                                    </div>
                                                    <div>
                                                        <p><span>PROFORMA NO :</span>{templateData.invoicePrefix || "NA"}_/{templateData.financialYear || "NA"}</p>
                                                        <p><span>ISSUE DATE :</span> NA</p>
                                                        <p><span>GSTIN :</span> {templateData.GSTIN || "NA"}</p>
                                                        <p><span>PAN : </span> {templateData.PAN || "NA"}</p>
                                                        <p><span>MSME TYPE : </span> {templateData.MSME_Type || "NA"}</p>
                                                        <p><span>MSME NO : </span> {templateData.MSME_Number || "NA"}</p>
                                                        <p><span>LUT ARN : </span> {templateData.Lut_Arn_No || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="inv_cost">
                                                    <Table bordered size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Description</th>
                                                                <th>SAC/HSN</th>
                                                                <th>QTY</th>
                                                                <th className="text-end">Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td className="text-end"><span>₹</span></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3} className="text-end">GSTN (12%) </th>
                                                                <td className="text-end"><span>₹</span></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3} className="text-end">TOTAL VALUE (IN FIGURE) </th>
                                                                <td className="text-end"><span>₹</span></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>TOTAL VALUE (IN WORDS) </th>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>SUPPLY ATTRACT REVERSE CHARGE (YES/NO)</th>
                                                                <td>No</td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>PAYMENT DUE DATE:</th>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>Without Payment of Tax under LUT No.</th>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                    <div className="noteText mb-4">

                                                    </div>
                                                    <div className="sign_sec mb-4">
                                                        <div className="note_de">
                                                            <p><b>Remarks :</b></p>
                                                            <p>text......</p>
                                                            <p className="mt-3"><b>Declaration:</b></p>
                                                            <p>
                                                                We declare that this document shows the actual price of the good/services described and that all particulars are true and correct.
                                                            </p>
                                                        </div>
                                                        <div className="sig">
                                                            <p><b>E. & O.E</b></p>
                                                            {signatureFile ? (
                                                                <img
                                                                    src={URL.createObjectURL(signatureFile)}
                                                                    alt="Signature"
                                                                    style={{ width: '80px', height: '80px' }}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={prevsignatureFile || require("../../assets/images/sign_n.png")}
                                                                    alt=''
                                                                />
                                                            )}


                                                            <p><small>{templateData.signatureBottomText || "NA"}</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="bankDet">
                                                        <p><span className="d-block">PAYMENT INFORMATION :</span>PAY BY CHEQUE/DD/RTGS/NEFT IN FAVOUR OF <br />{templateData.companyName || "NA"} </p>
                                                        <p><span className="d-block">BRANCH : </span> {templateData.bankBranch || "NA"}</p>
                                                        <p><span>BANK :</span> {templateData.bankName || "NA"}</p>
                                                        <p><span>A/C NO  :</span> {templateData.accountNumber || "NA"}</p>

                                                        <p><span>IFSC CODE : </span> {templateData.ifscCode || "NA"}</p>
                                                        <p><span>MSME NO : </span>  {templateData.MSME_Number || "NA"}</p>
                                                        <p><span>Swift Code : </span> {templateData.swiftCode || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="pdf-footer mt-4">
                                                    <p><small>{templateData.companyAddress || "NA"}</small></p>
                                                    <p><small>Call: {templateData.contactNo || "NA"} | Email: <a >{templateData.email || "NA"}</a></small></p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    )}
                </Row>
            </Row>
            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>
        </>
    );
};

export default Template_invoice_edit;
